import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterTipoReglaModel } from 'src/app/models/interfaces/tipo-regla/IFilterTipoReglaModel';
import { ITipoReglaModel } from 'src/app/models/interfaces/tipo-regla/ITipoReglaModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoReglaService {

  private configUrl = [environment.apiGatewayUrl, 'tipos-regla'].join('/');
  constructor(private http: HttpClient) { }

  getListFiltered(
    model: IFilterTipoReglaModel
    ) : Observable<SearchResultModel<ITipoReglaModel[]>> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    queryParams.push(`idEstado=${model.idEstado}`);
    
    if (model.nombre !== '') {
      queryParams.push(`nombre=${model.nombre}`);
    }

    return this.http.get<SearchResultModel<ITipoReglaModel[]>>(
      `${this.configUrl}/filtrar?${queryParams.join('&')}`
    );
  }

  getAllList(
    model: IFilterTipoReglaModel
    ) : Observable<ITipoReglaModel[]> {
    let queryParams: string[] = new Array<string>();

    // queryParams.push(`page=${model.page}`);
    // queryParams.push(`take=${model.pageSize}`);

    return this.http.get<ITipoReglaModel[]>(
      `${this.configUrl}/all?${queryParams.join('&')}`
    );
  }

  getById(id: number): Observable<ITipoReglaModel> {
    return this.http.get<ITipoReglaModel>(`${this.configUrl}/${id}`);
  }

  submit(model: ITipoReglaModel) {
    return this.http.post<ITipoReglaModel>(`${this.configUrl}`, model);
  }

  update(model: ITipoReglaModel) {
    return this.http.put<ITipoReglaModel>(
      `${this.configUrl}/${model.idTipoRegla}`,
      model
    );
  }

  delete(id: number) {
    return this.http.delete<ITipoReglaModel>(`${this.configUrl}/${id}`);
  }
}
